import { action, makeObservable, observable } from 'mobx';
import PushNotificationToken from '../models/pushNotificationToken';
import processIncomingData from '../processIncomingData';

class PushNotificationTokenStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable pushNotificationTokens = [];

  @action UpsertAndGet(incObj) {
    return processIncomingData(
      incObj,
      this.rootStore,
      this.pushNotificationTokens,
      PushNotificationToken
    );
  }
}

export default PushNotificationTokenStore;
